import { ModalWindow, Button } from '@cian/ui-kit';
import * as React from 'react';
import { InteractiveElementsWrapper } from '../../../InteractiveElementsWrapper';
import { ILabelLayoutProps } from '../../types';

export const LabelLayoutMobile: React.FC<React.PropsWithChildren<ILabelLayoutProps>> = ({
  tooltipTitle,
  tooltipContent,
  toggleTooltip,
  tooltipOpened,
  children,
  onClick,
  className,
}) => {
  return (
    <InteractiveElementsWrapper onClick={onClick} className={className}>
      {children}
      <ModalWindow
        title={tooltipTitle}
        content={tooltipContent}
        onClose={toggleTooltip}
        fixed
        footer={
          <Button theme="fill_primary" onClick={toggleTooltip} fullWidth size="L">
            Понятно
          </Button>
        }
        open={tooltipOpened}
      />
    </InteractiveElementsWrapper>
  );
};
